import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

import TableViewIcon from "@mui/icons-material/TableView";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import DialogApuramentoHeader from "pages/comercial/components/DialogApuramentoHeader";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

export default function DialogValorReceberFabricante({
  open,
  onClose,
  PaperComponent,
  acordo,

  fabricantesAcordosCombo,
  valorFabricanteInput,
  setValorFabricanteInput,
  valorReceberForm,
  setValorReceberForm,
  carregarFabricantesAcordosCombo,
  fabricanteLabel,

  consultarValorReceber,

  loadingExcelValorReceber,
  exportarValorReceberExcel,

  totalValorReceberFabricante,
  formatarMoeda,

  valorReceberColumns,
  valorReceberData,
  loading,
}) {
  const modoAcordo = Number(acordo?.id || 0) > 0;

  const nomeAcordo =
    acordo?.cliente && acordo?.refcliente
      ? `${acordo.cliente} (${acordo.refcliente})`
      : acordo?.cliente || acordo?.refcliente || "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        Valor a receber do fabricante
      </DialogTitle>

      <DialogContent>
        <MDBox display="grid" gap={1.5} mt={1}>
          {modoAcordo ? (
            <DialogApuramentoHeader
              tipo="Acordo"
              id={acordo?.id}
              nome={nomeAcordo}
              fabricante={acordo?.fabricante || acordo?.reffabricante}
              periodo={valorReceberForm}
              setPeriodo={setValorReceberForm}
              total={totalValorReceberFabricante}
              loading={loading}
              onRecalcular={consultarValorReceber}
            />
          ) : (
            <MDBox
              display="grid"
              gridTemplateColumns={{
                xs: "1fr",
                md: "2fr 1fr 1fr",
              }}
              gap={1.5}
            >
              <div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#7b809a",
                    marginBottom: 4,
                  }}
                >
                  Fabricante
                </div>

                <Autocomplete
                  size="small"
                  options={fabricantesAcordosCombo}
                  filterOptions={(x) => x}
                  inputValue={valorFabricanteInput}
                  getOptionLabel={fabricanteLabel}
                  value={
                    fabricantesAcordosCombo.find((f) => f.ref === valorReceberForm.reffabricante) ||
                    null
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      setValorFabricanteInput(value);

                      setValorReceberForm((anterior) => ({
                        ...anterior,
                        reffabricante: "",
                      }));

                      carregarFabricantesAcordosCombo(value);
                    }

                    if (reason === "clear") {
                      setValorFabricanteInput("");

                      setValorReceberForm((anterior) => ({
                        ...anterior,
                        reffabricante: "",
                      }));
                    }
                  }}
                  onChange={(_, value) => {
                    setValorReceberForm((anterior) => ({
                      ...anterior,
                      reffabricante: value?.ref || "",
                    }));

                    setValorFabricanteInput(value ? fabricanteLabel(value) : "");
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
                />
              </div>

              <div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#7b809a",
                    marginBottom: 4,
                  }}
                >
                  Data inicial
                </div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datainicial}
                  onChange={(e) =>
                    setValorReceberForm((anterior) => ({
                      ...anterior,
                      datainicial: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>

              <div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#7b809a",
                    marginBottom: 4,
                  }}
                >
                  Data final
                </div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datafinal}
                  onChange={(e) =>
                    setValorReceberForm((anterior) => ({
                      ...anterior,
                      datafinal: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>
            </MDBox>
          )}

          <MDBox
            display="flex"
            justifyContent={modoAcordo ? "flex-start" : "space-between"}
            alignItems="center"
            gap={1}
            flexWrap="wrap"
          >
            <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
              {!modoAcordo && (
                <MDButton color="info" onClick={consultarValorReceber}>
                  Consultar
                </MDButton>
              )}

              <MDButton
                startIcon={
                  loadingExcelValorReceber ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <TableViewIcon />
                  )
                }
                color="success"
                onClick={exportarValorReceberExcel}
                disabled={loadingExcelValorReceber}
              >
                {loadingExcelValorReceber ? "A gerar Excel..." : "Exportar Excel"}
              </MDButton>
            </MDBox>

            {!modoAcordo && (
              <MDTypography variant="h6">
                Total a receber: {formatarMoeda(totalValorReceberFabricante)} €
              </MDTypography>
            )}
          </MDBox>

          <ProjectTable
            tableKey="clientes-acordos-materiais-valor-receber"
            version="v1"
            columns={valorReceberColumns}
            data={valorReceberData}
            loading={loading}
            emptyMessage="Sem valores a receber para apresentar."
            minWidth={2100}
            maxHeight="50vh"
            showKeepFilters
          />
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
